import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Clienthad() {
  return (
    <section className="client_had p-100 text_chat">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              <span>The Client</span> Had?
            </h2>
            <p>
              The client had a huge number of token packages that needed to be
              added from the admin panel. They required technical expertise to
              do this and develop a smooth functioning app, and our experts took
              it from there.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <div className="client_img">
              <StaticImage
                src="../../../images/case-studies/our-chat/client.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={812}
                height={695}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Clienthad;
